import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { OAuthService, AuthConfig, OAuthEvent } from 'angular-oauth2-oidc';
// import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { Router, RouterModule } from '@angular/router';
import { AnalyticsService } from './services/analytics.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule]
})
export class AppComponent {
  title = 'Investing for Catholics';

  schema = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    'name': 'Investing for Catholics',
    'url': 'https://investingforcatholics.com'
  };

  constructor(
    private oauthService: OAuthService, 
    private router: Router, 
    private analytics: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    // console.log("environment.production:",environment.production)
    //Do not enforce login for public url https://investingforcatholics.com.
    //Only enforce login for other environments (e.g. staging.investingforcatholics.com)
    if (isPlatformBrowser(this.platformId)) {
      //console.log("window.location.host:",window.location.host)
      if (!environment.production || (window.location.host == "staging.investingforcatholics.com")) {
//       console.log("attempting to configure authentication...")
        this.configure();
      }
    }   
   
  }

  private configure() {
    // This method is only called from isPlatformBrowser check, but adding guard for safety
    if (typeof window === 'undefined') {
      return;
    }

    const authConfig: AuthConfig = {

      // Url of the Identity Provider
      issuer: 'https://auth.ifa.com',
    
      // URL of the SPA to redirect the user to after login
      redirectUri: window.location.origin + '',
    
      // The SPA's id. The SPA is registered with this id at the auth-server
      clientId: 'investingforcatholics.com',
    
      // set the scope for the permissions the client should request
      // The first three are defined by OIDC. The 4th is a usecase-specific one
      scope: 'openid profile email roles',
    }

    this.oauthService.configure(authConfig);
    //this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.loadDiscoveryDocumentAndTryLogin({ customHashFragment: window.location.hash }); 

    this.oauthService.events.subscribe((evt:OAuthEvent)=>{
      switch (evt.type) {
        case 'token_received':
          var session = sessionStorage.getItem('return_url')
          return this.router.navigateByUrl(session);
      }
//       console.log("OAuthEvent:",evt)
    })

  }

    public login() {
      this.oauthService.initLoginFlow();
    }

    public logoff() {
      this.oauthService.logOut();
    }

    public get name() {
      let claims = this.oauthService.getIdentityClaims();
      if (!claims) return null;
      return claims;
    }

    ngOnInit() {
      ///These are loaded from the index.html page... 
      // this.analytics.init(environment.googleAnalyticsKey)

      ///2026-02-24 - Noticed that the Adwords Key was blank? don't load blank keys.
      // this.analytics.init(environment.googleAdwordsKey)
    }
}
